import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'admissions-manager-sankey-flow-view-part',
	standalone: true,
	templateUrl: './sankey-flow-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./sankey-flow-view.part.scss'],
})
export class AdmissionsManagerSankeyFlowViewPart {
}